import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';

export const formatHour = (date) => {
    const m = moment(date).format('m')
    if (m === '0') {
        return moment(date).format('ha')
    }
    return moment(date).format('h:ma');
}

export const isNoTimeEvent = (event) => {
    return moment(event.start).isSame(event.end);
}

export const generateUuid = () => (
    /* from google calendar API event id field's doc:
        Opaque identifier of the event. When creating new single or recurring events, you can specify their IDs. Provided IDs must follow these rules:
        characters allowed in the ID are those used in base32hex encoding, i.e. lowercase letters a-v and digits 0-9, see section 3.1.2 in RFC2938
        the length of the ID must be between 5 and 1024 characters
        the ID must be unique per calendar
    */
    uuidv4().replaceAll('-', '')
)